import { useMutation } from '@tanstack/react-query';

import { authenticate, type AuthenticateResult } from '@/api/auth';
import { loginApi } from '../api/login.adapter';
import type {
  ChangePasswordInput,
  ForcedChangePasswordInput,
  LoginInput,
  SendResetCodeInput,
  VerifyResetCodeInput,
  VerifyResetCodeResult,
} from '../types/login.types';

export function useLoginMutation() {
  return useMutation<AuthenticateResult, unknown, LoginInput>({
    mutationFn: (input) => authenticate(input.email, input.password),
  });
}

export function useSendResetCodeMutation() {
  return useMutation<void, unknown, SendResetCodeInput>({
    mutationFn: (input) => loginApi.sendResetCode(input),
  });
}

export function useVerifyResetCodeMutation() {
  return useMutation<VerifyResetCodeResult, unknown, VerifyResetCodeInput>({
    mutationFn: (input) => loginApi.verifyResetCode(input),
  });
}

export function useChangePasswordMutation() {
  return useMutation<void, unknown, ChangePasswordInput>({
    mutationFn: (input) => loginApi.changePassword(input),
  });
}

export function useForcedChangePasswordMutation() {
  return useMutation<void, unknown, ForcedChangePasswordInput>({
    mutationFn: (input) => loginApi.forcedChangePassword(input),
  });
}
